module.exports = __webpack_public_path__ + "static/heritage-north-plat-map-243b1d5e7a26cf87befe7eafdc6a9538.jpg";